module.exports = __webpack_public_path__ + "static/media/SmileDr-SmileHappy-500x250-Animated.ae7e5a9d.mp4";